<template>
  <div class="index_box">
    <div class="banner">
      <div v-if="$i18n.locale === 'zh'">
        <div v-swiper:mySwiper="swiperOption">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in bgArrZh" :key="item.id">
              <a :href="item.jump_url ? item.jump_url : 'javascript:;'" :target="item.jump_url ? '_blank' : ''" style="display:block;">
                <img :src="item.img_url" alt="">
              </a>
            </div>
          </div>
        </div>
        <!-- <div class="swiper-pagination"></div> -->
      </div>
      <div v-else>
        <div v-swiper:mySwiper="swiperOption4" style="position:absolute;left:0;top:0;width:100%;height:100%;z-index:-1;">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in bgArrEn" :key="item.id">
              <a :href="item.jump_url ? item.jump_url : 'javascript:;'" :target="item.jump_url ? '_blank' : ''" style="display:block;">
                <img :src="item.img_url" alt="">
              </a>
            </div>
          </div>
          <!-- <div class="swiper-pagination"></div> -->
        </div>
      </div>
      <img class="wave" src="../../assets/images/wave.png" alt="">
      <!-- <div class="login" @click="changeLaguages">
        <img v-if="$i18n.locale === 'zh'" src="../../assets/images/en.png" alt="">
        <img v-else src="../../assets/images/zh.png" alt="">
      </div> -->
    </div>
    <div class="hot">
      <div class="loading" v-if="isItemsLoading"><img src="../../assets/images/loading.gif" alt=""></div>
      <div class="items" v-else>
        <div class="title">
          <img src="../../assets/images/left1.png" alt="">
          <p>精彩回放</p>
          <img src="../../assets/images/right1.png" alt="">
        </div>
        <div class="item" v-for="item in itemList.slice(0, 2)" :key="item.id" @click="getLink(item)">
          <div class="top" v-if="$i18n.locale === 'zh'">
            <img :src="item.thumbnailUrl" alt="">
          </div>
          <div class="top" v-else>
            <img :src="item.lang.thumbnailUrl" alt="">
          </div>
          <div class="bottom">
            <p v-if="$i18n.locale === 'zh'">{{item.title}}</p>
            <p v-else>{{item.lang.title}}</p>
            <div class="playbutton" v-if="$i18n.locale === 'zh'">
              <div class="replay">观看回放</div>
            </div>
          </div>
        </div>
        <div class="item" v-for="item in itemList.slice(2, 4)" :key="item.id" @click="getLink(item)">
          <div class="top" v-if="$i18n.locale === 'zh'">
            <img :src="item.thumbnailUrl" alt="">
          </div>
          <div class="top" v-else>
            <img :src="item.lang.thumbnailUrl" alt="">
          </div>
          <div class="bottom">
            <p v-if="$i18n.locale === 'zh'">{{item.title}}</p>
            <p v-else>{{item.lang.title}}</p>
            <div class="playbutton" v-if="$i18n.locale === 'zh'">
              <div class="replay">观看回放</div>
            </div>
          </div>
        </div>
        <div class="item" v-for="item in showHighlights" :key="item.id" @click="getLink(item)">
          <div class="top" v-if="$i18n.locale === 'zh'">
            <img :src="item.thumbnailUrl" alt="">
          </div>
          <div class="top" v-else>
            <img :src="item.lang.thumbnailUrl" alt="">
          </div>
          <div class="bottom">
            <p v-if="$i18n.locale === 'zh'">{{item.title}}</p>
            <p v-else>{{item.lang.title}}</p>
            <div class="playbutton" v-if="$i18n.locale === 'zh'">
              <div class="replay">观看回放</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sponsor" v-show="!isItemsLoading">
      <div>
        <div class="img_box">
          <img src="../../assets/images/logobg.png" alt="">
          <div>{{$t('lang.zddw')}}</div>
        </div>
        <div class="sponsor_top">
          <div>
            <p><span>{{$t('lang.fgw')}}</span></p>
            <p><span>{{$t('lang.zgc')}}</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="sponsor" v-show="!isItemsLoading">
      <div>
        <div class="img_box">
          <img src="../../assets/images/logobg.png" alt="">
          <div>{{$t('lang.djhzhb')}}</div>
        </div>
        <div class="sponsor_top">
          <div class="tops">
            <img src="../../assets/images/top0.jpg" alt="">
            <img src="../../assets/images/top1.jpg" alt="">
            <img src="https://static.gmic.cn/gmicpro/logos/brand/32.jpg" alt="">
            <img src="../../assets/images/top3.jpg" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="sponsor" v-show="!isItemsLoading">
      <div>
        <div class="img_box">
          <img src="../../assets/images/logobg.png" alt="">
          <div>{{$t('lang.nrhzhb')}}</div>
        </div>
        <div class="sponsor_top">
          <div class="tops">
            <img src="https://static.gmic.cn/gmicpro/logos/content/1.jpg" alt="">
            <img src="https://static.gmic.cn/gmicpro/logos/content/2.jpg" alt="">
            <img src="https://static.gmic.cn/gmicpro/logos/content/3.jpg" alt="">
            <img src="https://static.gmic.cn/gmicpro/logos/content/4.jpg" alt="">
            <img src="https://static.gmic.cn/gmicpro/logos/content/5.jpg" alt="">
            <img src="https://static.gmic.cn/gmicpro/logos/content/6.jpg" alt="">
            <img src="https://static.gmic.cn/gmicpro/logos/content/8.jpg" alt="">
            <img src="https://static.gmic.cn/gmicpro/logos/content/9.jpg" alt="">
            <img src="https://static.gmic.cn/gmicpro/logos/content/7.jpg" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="sponsor" v-show="!isItemsLoading">
      <div>
        <div class="img_box">
          <img src="../../assets/images/logobg.png" alt="">
          <div>{{$t('lang.pphzhb')}}</div>
        </div>
        <div class="logos sponsor_top">
          <div>
            <div id="pptoleft" class="toleft">
              <ul>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/2.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/3.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/6.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/8.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/9.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/12.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/14.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/15.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/16.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/17.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/18.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/30.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/31.jpg" alt=""></li>
              </ul>
            </div>
            <div id="pptoright" class="toright">
              <ul>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/19.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/20.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/21.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/22.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/23.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/24.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/25.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/26.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/27.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/28.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/29.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/33.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/logos/brand/34.jpg" alt=""></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sponsor" v-show="!isItemsLoading">
      <div>
        <div class="img_box">
          <img src="../../assets/images/logobg.jpg" alt="">
          <router-link to="/medias" style="position:absolute;width:100%;height:100%;left:0;top:0;z-index:2;"></router-link>
          <div>{{$t('lang.mt')}}</div>
        </div>
        <div class="logos sponsor_top">
          <div>
            <div id="mttoleft" class="toleft">
              <ul>
                <li><img src="https://static.gmic.cn/gmicpro/media/1.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/media/2.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/media/3.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/media/4.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/media/5.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/media/6.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/media/7.jpg" alt=""></li>
              </ul>
            </div>
            <div id="mttoright" class="toright">
              <ul>
                <li><img src="https://static.gmic.cn/gmicpro/media/8.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/media/9.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/media/10.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/media/11.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/media/12.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/media/13.jpg" alt=""></li>
                <li><img src="https://static.gmic.cn/gmicpro/media/14.jpg" alt=""></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="kp" v-if="isKpShow">
      <div class="bg"></div>
      <div class="kp_content">
        <div class="items">
          <p>注册立享N重福利</p>
          <div class="items_box">
            <div class="item">
              <img src="../../assets/images/1.png" alt="">
              <div>
                <p class="kp_title">个性化推荐</p>
                <p>千人千面，给你想看</p>
              </div>
            </div>
            <div class="item">
              <img src="../../assets/images/2.png" alt="">
              <div>
                <p class="kp_title">与嘉宾面对面</p>
                <p>约你视频连麦</p>
              </div>
            </div>
            <div class="item">
              <img src="../../assets/images/3.png" alt="">
              <div>
                <p class="kp_title">"高老庄"小店</p>
                <p>领取"无门槛"优惠券</p>
              </div>
            </div>
            <div class="item">
              <img src="../../assets/images/4.png" alt="">
              <div>
                <p class="kp_title">评论弹幕</p>
                <p>多重好礼抽奖狂送</p>
              </div>
            </div>
          </div>
          <div class="login_btn">
            <router-link to="/login">{{$t('lang.ljzc')}}</router-link>
          </div>
        </div>
        <div class="closediv"><div style="width:50px;height:50px;position:absolute;top:-9px;left:-9px;" @click="closeKp"></div><img src="../../assets/images/popupclose.svg"><div><hr></div></div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "index.less";
</style>
<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ModalApi from '../../components/ModalApi'
// import XiaoJi from '../../components/xiaoji'
// import NavBar from '../../components/navbar'
let splide1, splide2, splidepp1, splidepp2
let oul1, oul2, oulpp1, oulpp2
const mainstageLink = 'http://v.gmic.cn/watch/7558867'
const sideStageLink = 'http://v.gmic.cn/watch/7639481'
const mainstageENLink = 'https://youtu.be/-InAj8Mep3c'
const sideStageENLink = 'https://youtu.be/8GKX5movEUE'
const mainStageStarTime = new Date('2020-09-24T18:00:00+08:00')
const sideStageStarTime = new Date('2020-09-25T08:00:00+08:00')
export default {
  mixins: [ModalApi],
  name: 'swiper-example-default',
  title: 'Default',
  data () {
    return {
      swiperOption: {
        loop: true,
        autoplay: 4000
      },
      swiperOption4: {
        loop: true,
        autoplay: 4000
      },
      swiperOption2: {
        // pagination: {
        //   el: '.swiper-pagination'
        // },
        pagination: '.swiper-pagination2',
        loop: true,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false
        // },
        autoplay: 3000
      },
      swiperOption3: {
        loop: true,
        notNextTick: true,
        autoplay: 3000
      },
      // swiperOption5: {
      //   pagination: '.swiper-pagination5',
      //   loop: true,
      //   autoplay: 3000
      // },
      timer1: null,
      move: null,
      itemList: [],
      adList1: [],
      adList2: [],
      isItemsLoading: true,
      bgArrZh: [
        {
          id: 0,
          jump_url: '',
          img_url: 'https://static.gmic.cn/gmicpro/banners/probanner.jpg'
        }
      ],
      bgArrEn: [
        {
          id: 0,
          jump_url: '',
          img_url: 'https://static.gmic.cn/gmicpro/banners/probanneren.jpg'
        }
      ],
      showHighlights: [],
      nowIndex: 4,
      ppi: 0,
      i: 0,
      lang: 'zh',
      isPPLoading: true,
      ppList: [],
      isKpShow: false
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  created () {
    let self = this
    self.ifKpShow()
    // console.log(this.$store.state.login.finishStatus)
    self.getAdList()
    self.getDataList()
    self.getPPList()
  },
  watch: {
    '$i18n.locale': {
      handler: function (newer, older) {
        this.getAdList()
      },
      deep: true // 开启深度监听
    }
  },
  mounted () {
    let self = this
    self.$nextTick(function () {
      window.addEventListener('scroll', self.handleScroll, true)
      splide1 = document.getElementById('mttoleft')
      splide2 = document.getElementById('mttoright')
      splidepp1 = document.getElementById('pptoleft')
      splidepp2 = document.getElementById('pptoright')
      oul1 = splide1.getElementsByTagName('ul')[0]
      oul2 = splide2.getElementsByTagName('ul')[0]
      oulpp1 = splidepp1.getElementsByTagName('ul')[0]
      oulpp2 = splidepp2.getElementsByTagName('ul')[0]
      oul1.innerHTML += oul1.innerHTML
      oul2.innerHTML += oul2.innerHTML
      oulpp1.innerHTML += oulpp1.innerHTML
      oulpp2.innerHTML += oulpp2.innerHTML
      self.move = function (num, obj) {
        let speed = num * 1
        if (obj.offsetLeft < -obj.offsetWidth / 2) {
          obj.style.left = '0'
        }
        if (obj.offsetLeft > 0) {
          obj.style.left = -obj.offsetWidth / 2 + 'px'
        }
        obj.style.left = obj.offsetLeft + speed + 'px'
      }
      self.timer1 = setInterval(function () {
        self.move(1, oul1)
        self.move(-1, oul2)
        self.move(1, oulpp1)
        self.move(-1, oulpp2)
      }, 50)
    })
  },
  methods: {
    getDataList: function () {
      let self = this
      self.$http.get('https://goapi.gmic.cn/api/v1/room/playbacks').then(function (res) {
        console.log(res)
        if (res.data.code === 200) {
          // for (let i = 0; i < res.data.message.ads.length; i++) {
          //   let ad = res.data.message.ads[i]
          //   if (ad.group === 1) {
          //     self.adList1.push(ad)
          //   } else {
          //     self.adList2.push(ad)
          //   }
          // }
          // res.data.data[0].status = 1
          self.itemList = res.data.data
          self.isItemsLoading = false
        }
      }).catch(function (err) {
        self.isItemsLoading = true
        console.log(err)
      })
    },
    getDay: function (time) {
      // time = time.toString().replace(/-/g, '/')
      let thismonth = new Date(time).getMonth() + 1
      let thisdate = new Date(time).getDate()
      let thisday
      if (this.$i18n.locale === 'zh') {
        thisday = thismonth + '月' + thisdate + '日'
      } else {
        thisday = 'Sep ' + thisdate + 'th'
      }
      return thisday
    },
    getTime: function (time) {
      let thistime = time.substring(11, 16)
      return thistime
    },
    handleScroll: function () {
      let self = this
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let documentHeight = document.body.scrollHeight
      let windowHeight = document.documentElement.clientHeight
      if (scrollTop + windowHeight > documentHeight - 800) {
        let remain = self.itemList.length - self.nowIndex
        if (remain > 4) {
          self.showHighlights = self.showHighlights.concat(self.itemList.slice(self.nowIndex, self.nowIndex + 5))
          self.nowIndex += 5
        } else if (remain <= 4 && remain > 0) {
          self.showHighlights = self.showHighlights.concat(self.itemList.slice(self.nowIndex, self.nowIndex + remain))
          self.nowIndex += remain
        }
      }
    },
    changeLaguages () {
      // console.log(this.$i18n.locale)
      let lang = this.$i18n.locale
      if (lang === 'zh') {
        localStorage.setItem('locale', 'en')
        this.$i18n.locale = localStorage.getItem('locale')
      } else if (lang === 'en') {
        localStorage.setItem('locale', 'zh')
        this.$i18n.locale = localStorage.getItem('locale')
      }
    },
    getPPList: function () {
      let self = this
      self.$http.get('https://goapi.gmic.cn/api/v1/room/top_brands').then(function (res) {
        // console.log(res)
        if (res.data.code === 200) {
          self.ppList = res.data.data
          self.isPPLoading = false
        }
      }).catch(function (err) {
        self.isPPLoading = true
        console.log(err)
      })
    },
    getAdList: function () {
      let self = this
      let lang = 'zh-cn'
      if (self.$i18n.locale === 'zh') {
        lang = 'zh-cn'
      } else {
        lang = 'en-us'
      }
      self.$http.get('https://goapi.gmic.cn/api/v1/adverts?lang=' + lang).then(function (res) {
        // console.log(res.data.data.adverts)
        if (res.data.code === 200) {
          self.bgArrZh = []
          self.bgArrEn = []
          if (lang === 'zh-cn') {
            self.bgArrZh = res.data.data.banners
          } else {
            self.bgArrEn = res.data.data.banners
          }
          self.adList1 = res.data.data.adverts
          // self.adList2 = res.data.data.adverts.filter(item => item.type === 0)
        }
      }).catch(function (err) {
        console.log(err)
      })
    },
    getLink: function (item) {
      let self = this
      let finishStatus = self.$store.state.login.finishStatus
      let jump = localStorage.getItem('isClickJump')
      if (!finishStatus && !jump) {
        self.$router.replace({
          path: '/login'
        })
        return
      }
      if (self.$i18n.locale === 'zh') {
        self.$router.push({
          path: '/video',
          query: {id: item.playBack.aes_id}
        })
      }
    },
    getLinkPp: function (item) {
      let self = this
      if (item.status === 0) {
        self.alert(self.$t('lang.unstart'), self.$t('lang.ts'), self.$t('lang.qr'))
        return
      }
      if (item.status === -1) {
        self.alert(self.$t('lang.end'), self.$t('lang.ts'), self.$t('lang.qr'))
        return
      }
      if (item.status === 1) {
        window.location.href = item.streamMuduUrl
      }
    },
    getLinkBtn: function (mainStage) {
      let mainLink = this.$i18n.locale === 'zh' ? mainstageLink : mainstageENLink
      let sideLink = this.$i18n.locale === 'zh' ? sideStageLink : sideStageENLink
      let targetLink = mainStage ? mainLink : sideLink
      let self = this
      let finishStatus = self.$store.state.login.finishStatus
      let jump = localStorage.getItem('isClickJump')
      if (!finishStatus && !jump) {
        self.$router.replace({
          path: '/login'
        })
        return
      }
      // 跳转
      let enableClick = false
      if (mainStage) {
        enableClick = new Date() > mainStageStarTime
      } else {
        enableClick = new Date() > sideStageStarTime
      }

      if (enableClick) {
        window.location.href = targetLink
      } else {
        self.alert(self.$t('lang.unstart'), self.$t('lang.ts'), self.$t('lang.qr'))
      }
    },
    ifKpShow: function () {
      let self = this
      if (self.$i18n.locale === 'en') {
        return
      }
      let finishStatus = self.$store.state.login.finishStatus
      if (finishStatus) {
        return
      }
      console.log(sessionStorage.getItem('hasKpClosed'))
      if (!sessionStorage.getItem('hasKpClosed')) {
        self.isKpShow = true
        document.body.style.overflowY = 'hidden'
      }
    },
    closeKp: function () {
      sessionStorage.setItem('hasKpClosed', '1')
      document.body.style.overflowY = 'auto'
      this.isKpShow = false
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll, true)
    clearInterval(this.timer1)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index/indexReplay.vue